<template>
  <div class="head-page">
    <Header />
    <van-form @submit="onSubmit">
      <van-field
        :label="$t('register.email')"
        v-model="frm.email"
        name="validatortmp"
        :placeholder="$t('register.emailplaceholder')"
        :rules="[
          { required: true },
          {
            validator: validatortmp,
            message: $t('register.emailplaceholder')
          }
        ]"
      />
      <van-field
        :label="$t('other.verify_code')"
        v-model="frm.code"
        center
        clearable
        :placeholder="$t('bank.verify_code')"
        :rules="[{ required: true }]"
      >
        <template #button>
          <span v-if="num == 0" class="link-btn" @click="sendCode">{{
            $t('bank.sendcode')
          }}</span>
          <span v-else>{{ $t('bank.sended', { num, num }) }}</span>
        </template>
      </van-field>
      <van-field
        v-model="frm.password"
        type="password"
        :label="$t('security.loginpwd')"
        :placeholder="$t('security.loginnewpwdplaceholder')"
        :rules="[{ required: true }]"
      />
      <van-field
        v-model="password"
        type="password"
        name="validator"
        :label="$t('security.pwdage')"
        :placeholder="$t('security.pwdageplaceholder')"
        :rules="[
          { required: true },
          { validator, message: $t('register.agepwdplaceholder1') }
        ]"
      />
      <div style="margin: 16px">
        <van-button class="web-btn" native-type="submit">
          <van-loading v-if="posting" /><span v-else>
            {{ $t('common.submit') }}</span
          ></van-button
        >
      </div>
    </van-form>
  </div>
</template>

<script>
import Header from '@/components/Header'
import { removeToken, getToken } from '@/utils/cookies'
export default {
  name: 'FindPwd',
  components: { Header },
  data () {
    return {
      password:null,
      frm: {
        code: null,
        email: null,
        password: null
      },
      posting: false,
      num: 0,
      timer: null
    }
  },
  beforeDestroy () {
    if (this.timer) clearInterval(this.timer)
  },
  mounted () {
    if (getToken()) {
      this.$router.push({ name: 'home' })
    }
  },
  methods: {
    validatortmp (val) {
      let regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      if (this.frm.type != 2) {
        regex = /^\d{6,20}$/
      }
      return regex.test(val)
    },
    async onSubmit () {
      if (this.posting) {
        return
      }
      this.posting = true
     
      await this.$http({
        method: 'post',
        url: 'findUsrPwd',
        data: this.frm
      })
        .then(res => {
          this.posting = false
          this.$toast.success(res.msg);
          removeToken()
          this.$router.push({ name: "login" });
        })
        .catch(() => {
          this.posting = false
        })
    },
    validator (val) {
      return this.frm.password == val
    },
    async sendCode () {
      await this.$http({
        method: 'post',
        url: 'emssend',
        data: { email: this.frm.email }
      }).then((res) => {
        if(res.code == 1){
        this.num = 60
        const that = this
        this.$nextTick(() => {
          that.timer = setInterval(() => {
            if (that.num >= 0) that.num -= 1
            else {
              that.num = 0
              if (that.timer) clearInterval(that.timer)
            }
          }, 1000)
        })
        }
      })

    }
  }
}
</script>

<style></style>
